module.exports = __webpack_public_path__ + "static/media/wrap_text.eed306f3.svg";